import * as React from 'react';
export const pulseSvg = React.forwardRef(function pulseSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.376 8.607h.858c.21 0 .406-.174.434-.384l.038-.255c.047-.256-.12-.412-.33-.412h-.843l-.157 1.05ZM1.22 9.639l-.176 1.179c-.011-.004-1.045 0-1.045 0l.629-4.213h2.024c.69 0 1.174.556 1.083 1.246l-.079.528c-.091.689-.735 1.26-1.424 1.26H1.22Zm14.498-.254v-.07h.061c.03 0 .035.02.035.034 0 .026-.013.036-.038.036h-.058Zm-.049.146h.049v-.102h.05c.037 0 .04.014.04.049 0 .027.001.04.004.053h.055v-.007c-.01-.005-.01-.014-.01-.052 0-.049-.011-.057-.03-.066.023-.009.036-.034.036-.062 0-.023-.011-.074-.074-.074h-.12v.26Zm.1.08c-.109 0-.197-.094-.198-.21 0-.115.088-.21.197-.21.108 0 .197.093.197.209 0 .115-.087.21-.196.21Zm0 .038c.128 0 .232-.112.231-.25 0-.137-.104-.248-.232-.247-.129 0-.232.112-.231.25 0 .136.104.247.232.247Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm14.69 7.685.017-.12a.154.154 0 0 0-.155-.18h-.838c-.1 0-.191.08-.205.18l-.017.12h1.199Zm-1.755 1.954c-.413 0-.73-.336-.674-.749l.226-1.516c.056-.413.448-.769.861-.769h1.716c.418 0 .711.356.655.77l-.153 1.024h-2.18l-.044.3 1.772.001c.274-.003.366.248.33.515l-.063.424h-2.446Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm8.36 9.639.6-4.017c.04-.241.02-.596-.387-.622h-.607L7.27 9.639h1.09Zm-1.46 0 .452-3.034h-1.08l-.298 2.004h-.723c-.146 0-.27-.094-.241-.275l.165-1.1c.034-.225.054-.627-.317-.629h-.685l-.3 2.007c-.092.67.26 1.027.704 1.027H6.9Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm1.438 10.818.111-.775h13.772l-.064.452c-.035.22-.148.323-.325.323H1.438ZM9.85 6.605c-.388 0-.705.342-.766.754l-.057.378c-.052.398.163.734.532.754h1.365l-.033.21h-1.5c-.268.001-.53.027-.565.299l-.098.639h2.413c.397 0 .768-.264.822-.676l.078-.518c.054-.411-.229-.755-.627-.755H10.03l.026-.196h1.58c.399 0 .523-.048.577-.345l.081-.544H9.85Z',
    }),
  );
});
pulseSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pulse = {
  category: 'paymentmethod',
  colorable: true,
  name: 'pulse',
  svg: pulseSvg,
};
